module.exports = __webpack_public_path__ + "img/MoitorCenter2driver.png";